module.exports = __webpack_public_path__ + "img/1696514632983.fa296441.jpeg";